"use strict";
export const INTERNAL_MAINNET_FEWTOKEN_LP_CANDIDATES = [
  {
    chainId: 1,
    address: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    decimals: 18,
    symbol: "WETH",
    name: "Wrapped Ether",
    extensions: {
      fewWrappedAddress: "0xa250cC729bb3323e7933022a67B52200Fe354767",
      fewName: "Few Wrapped Wrapped Ether",
      fewSymbol: "fwWETH"
    }
  },
  {
    chainId: 1,
    address: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
    decimals: 6,
    symbol: "USDT",
    name: "Tether USD",
    extensions: {
      fewWrappedAddress: "0xef87f4608e601E8564800265AeE1c1FfaDF73283",
      fewName: "Few Wrapped Tether USD",
      fewSymbol: "fwUSDT"
    }
  },
  {
    chainId: 1,
    address: "0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984",
    decimals: 18,
    symbol: "UNI",
    name: "Uniswap",
    extensions: {
      fewWrappedAddress: "0xE8E1f50392bd61d0F8f48e8e7aF51D3B8a52090A",
      fewName: "Few Wrapped Uniswap",
      fewSymbol: "fwUNI"
    }
  },
  {
    chainId: 1,
    address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48",
    decimals: 6,
    symbol: "USDC",
    name: "USD Coin",
    extensions: {
      fewWrappedAddress: "0x0492560FA7Cfd6A85E50D8bE3F77318994F8f429",
      fewName: "Few Wrapped USD Coin",
      fewSymbol: "fwUSDC"
    }
  },
  {
    chainId: 1,
    address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    decimals: 18,
    symbol: "DAI",
    name: "Dai Stablecoin",
    extensions: {
      fewWrappedAddress: "0x8A6fe57C08C84e0f4eE97aAe68a62e820a37d259",
      fewName: "Few Wrapped Dai Stablecoin",
      fewSymbol: "fwDAI"
    }
  },
  {
    chainId: 1,
    address: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
    decimals: 8,
    symbol: "cbBTC",
    name: "Coinbase Wrapped BTC",
    extensions: {
      fewWrappedAddress: "0xDbf1703e5d29afEfbF1bD958ce7a6023c67f3E5d",
      fewName: "Few Wrapped Coinbase Wrapped BTC",
      fewSymbol: "fwcbBTC"
    }
  },
  {
    chainId: 1,
    address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    decimals: 8,
    symbol: "WBTC",
    name: "Wrapped BTC",
    extensions: {
      fewWrappedAddress: "0x2078f336Fdd260f708BEc4a20c82b063274E1b23",
      fewName: "Few Wrapped Wrapped BTC",
      fewSymbol: "fwWBTC"
    }
  },
  {
    chainId: 1,
    address: "0xCd5fE23C85820F7B72D0926FC9b05b43E359b7ee",
    decimals: 18,
    symbol: "weETH",
    name: "Wrapped eETH",
    extensions: {
      fewWrappedAddress: "0x9553d5F1f564EDE30f5a9F0274cD0AF7A00546e7",
      fewName: "Few Wrapped Wrapped eETH",
      fewSymbol: "fwweETH"
    }
  },
  {
    chainId: 1,
    address: "0x7f39C581F595B53c5cb19bD0b3f8dA6c935E2Ca0",
    decimals: 18,
    symbol: "wstETH",
    name: "Wrapped liquid staked Ether 2.0",
    extensions: {
      fewWrappedAddress: "0xB90e63487bc6A4fa3d58F707510Dab3C28a63137",
      fewName: "Few Wrapped Wrapped liquid staked Ether 2.0",
      fewSymbol: "fwwstETH"
    }
  }
];
